export default `/* Ids Text Component */
:host([hidden]) {
  display: none !important;
}

:host([overflow=ellipsis]) {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
}

:host([mask-type=button-mask]),
:host([mask-type=icon-mask]) {
  display: flex;
  align-items: center;
  gap: var(--ids-text-mask-btn-gap);
}
:host([mask-type=button-mask]) .mask-btn,
:host([mask-type=icon-mask]) .mask-btn {
  display: flex;
}

.ids-text {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-weight: var(--ids-font-weight-normal);
  display: block;
  margin: 0;
  color: currentColor;
  font-size: var(--ids-font-size-sm);
  text-decoration: unset;
}
.ids-text.audible {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  position: none;
}
.ids-text.error {
  color: var(--ids-color-text-error);
}
.ids-text.label {
  color: var(--ids-color-text-label);
}
.ids-text.label.color-variant-alternate {
  color: var(--ids-color-text-inverse);
}
.ids-text.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-text.ellipsis div.has-tab-width {
  max-width: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-text.has-line-clamp {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  /* stylelint-disable-next-line property-no-deprecated */
  word-wrap: break-word;
}
.ids-text.bold {
  font-weight: var(--ids-font-weight-bold);
}
.ids-text.semi-bold {
  font-weight: var(--ids-font-weight-semibold);
}
.ids-text.lighter {
  font-weight: var(--ids-font-weight-light);
}
.ids-text.text-align-start {
  text-align: start;
}
.ids-text.text-align-end {
  text-align: end;
}
.ids-text.text-align-center {
  text-align: center;
}
.ids-text.text-align-justify {
  text-align: justify;
}
.ids-text.status-gray::before, .ids-text.status-error::before, .ids-text.status-info::before, .ids-text.status-success::before, .ids-text.status-warning::before {
  display: inline-flex;
  margin-inline-end: var(--ids-input-margin-bottom);
  border-radius: var(--ids-border-radius-circle);
  content: "";
  height: 8px;
  width: 8px;
  position: relative;
  top: -2px;
}
.ids-text.status-gray {
  color: var(--ids-color-text-label);
}
.ids-text.status-gray::before {
  background-color: var(--ids-color-text-label);
}
.ids-text.status-error {
  color: var(--ids-color-text-error);
}
.ids-text.status-error::before {
  background-color: var(--ids-color-text-error);
}
.ids-text.status-info {
  color: var(--ids-color-text-info);
}
.ids-text.status-info::before {
  background-color: var(--ids-color-text-info);
}
.ids-text.status-success {
  color: var(--ids-color-text-success);
}
.ids-text.status-success::before {
  background-color: var(--ids-color-text-success);
}
.ids-text.status-warning {
  color: var(--ids-color-text-warning);
}
.ids-text.status-warning::before {
  background-color: var(--ids-color-text-warning);
}
.ids-text.pre {
  white-space: pre;
}
.ids-text.pre-wrap {
  white-space: pre-wrap;
}
.ids-text.nowrap {
  white-space: nowrap;
}
.ids-text.pre-line {
  white-space: pre-line;
}
.ids-text.break-spaces {
  white-space: break-spaces;
}
.ids-text.normal {
  white-space: normal;
}
.ids-text.word-break-normal {
  word-break: normal;
}
.ids-text.word-break-break-all {
  word-break: break-all;
}
.ids-text.word-break-keep-all {
  word-break: keep-all;
}
.ids-text.word-break-break-word {
  overflow-wrap: anywhere;
}

:host(.inline) .ids-text {
  display: inline;
}

:host([word-wrap]) {
  white-space: normal;
  /* stylelint-disable-next-line property-no-deprecated */
  word-wrap: break-word;
}

.inline,
[display=inline] {
  display: inline;
}

.ids-text-color-unset {
  color: unset;
}

:host(.message-text) .ids-text {
  color: unset;
}
:host(.message-text) .ids-text.error {
  color: unset;
}

::slotted(.highlight) {
  font-weight: var(--ids-font-weight-bold);
}

::slotted(.audible) {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

::slotted(.filter) {
  font-weight: var(--ids-font-weight-bold);
}

::slotted(ids-icon) {
  margin-inline-end: var(--ids-text-icon-margin);
  vertical-align: middle;
  position: relative;
  top: -2px;
}

:host([font-size="32"]) ::slotted(ids-icon),
:host([font-size="28"]) ::slotted(ids-icon),
:host([font-size="24"]) ::slotted(ids-icon),
:host([font-size="20"]) ::slotted(ids-icon) {
  margin-inline-end: var(--ids-text-icon-margin-lg);
}

::slotted(ids-alert) {
  margin: var(--ids-text-alert-margin);
  vertical-align: sub;
}

/* Ids Typography System */
.ids-text-10 {
  font-size: var(--ids-font-size-3xs);
  text-transform: uppercase;
}

.ids-text-12 {
  font-size: var(--ids-font-size-2xs);
  text-transform: uppercase;
}

.ids-text-14 {
  font-size: var(--ids-font-size-xs);
}

.ids-text-16 {
  font-size: var(--ids-font-size-sm);
}

.ids-text-20 {
  font-size: var(--ids-font-size-md);
}

.ids-text-24 {
  font-size: var(--ids-font-size-lg);
}

.ids-text-28 {
  font-size: var(--ids-font-size-xl);
}

.ids-text-32 {
  font-size: var(--ids-font-size-2xl);
}

.ids-text-40 {
  font-size: var(--ids-font-size-3xl);
}

.ids-text-48 {
  font-size: var(--ids-font-size-4xl);
}

.ids-text-60 {
  font-size: var(--ids-font-size-5xl);
}

.ids-text-72 {
  font-size: var(--ids-font-size-6xl);
  margin-block-end: 0;
}

.ids-text-color-muted.ids-text,
:host([disabled]) .ids-text {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.label,
:host([disabled]) .ids-text.label {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.color-variant-alternate.label,
:host([disabled]) .ids-text.color-variant-alternate.label {
  color: var(--ids-color-text-subtle);
}
.ids-text-color-muted.ids-text.status-base, .ids-text-color-muted.ids-text.status-error, .ids-text-color-muted.ids-text.status-info, .ids-text-color-muted.ids-text.status-success, .ids-text-color-muted.ids-text.status-warning,
:host([disabled]) .ids-text.status-base,
:host([disabled]) .ids-text.status-error,
:host([disabled]) .ids-text.status-info,
:host([disabled]) .ids-text.status-success,
:host([disabled]) .ids-text.status-warning {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.status-error::before, .ids-text-color-muted.ids-text.status-info::before, .ids-text-color-muted.ids-text.status-success::before, .ids-text-color-muted.ids-text.status-warning::before,
:host([disabled]) .ids-text.status-error::before,
:host([disabled]) .ids-text.status-info::before,
:host([disabled]) .ids-text.status-success::before,
:host([disabled]) .ids-text.status-warning::before {
  background-color: var(--ids-color-text-disabled);
}

:host([class=label-checkbox]) .audible {
  position: relative;
  line-height: 1;
  height: unset;
}

::slotted(ids-badge) {
  position: relative;
  margin-inline-start: 8px;
  top: 1px;
  vertical-align: top;
}

:host([label-wrap=ellipsis]) .ids-text {
  display: block;
  width: 100%;
  max-inline-size: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host([label-wrap=ellipsis-no-stretch]) .ids-text {
  display: block;
  max-inline-size: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host([label-wrap=wrap-no-stretch]) .ids-text {
  max-inline-size: 75%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
